import React from "react";

import {cn} from "@isudio/utils";
import {type IAssetFilter, type IAssetSort, AssetFilters, AssetSorts} from "@isudio/data";

import {FilterDropdown, SortDropdown} from "./";

interface DropdownsProps {
  className?: string;
  filters?: IAssetFilter[];
  sorts?: IAssetSort[];
  onFilterChange?: (filter: IAssetFilter) => void;
  onSortChange?: (filter: IAssetSort) => void;
}

const Dropdowns = React.forwardRef<Element, DropdownsProps>(
  ({
     className = "header-dropdowns",
     filters = AssetFilters,
     sorts = AssetSorts,
     onFilterChange,
     onSortChange
   }
  ) => {
    return (
      <div
        className={cn(`${className}`, "h-8 flex justify-center align-center gap-2")}
      >
        <FilterDropdown
          filters={filters}
          onChange={onFilterChange}
        />

        <SortDropdown
          sorts={sorts}
          onChange={onSortChange}
        />
      </div>
    )
  }
);

Dropdowns.displayName = "Dropdowns"
export {Dropdowns}